import { BoardMediaImageErrorForm } from "./board-media-image-error-form";
import type { BoardMediaImageErrorRender } from "./board-media-image-error-render";

interface BoardMediaImageErrorDeps {
    render: BoardMediaImageErrorRender;
}

class BoardMediaImageError {
    public render: BoardMediaImageErrorRender;

    private readonly form: BoardMediaImageErrorForm;

    public constructor(deps: BoardMediaImageErrorDeps) {
        this.render = deps.render;
        this.form = new BoardMediaImageErrorForm();
    }

    public handleImageError(event: Event): void {
        const target = this.form.getEventTarget(event);
        if (!(target instanceof HTMLImageElement)) return;
        if (!(this.form.getBoardMediaArea(target) instanceof HTMLElement)) return;

        this.render.replaceBrokenImage(target);
    }

    public replaceAlreadyBrokenImages(root: ParentNode = document): void {
        const images = this.form.getImages(root);
        images.forEach((img) => {
            if (img.complete && img.naturalWidth === 0) {
                this.render.replaceBrokenImage(img);
            }
        });
    }
}

export { BoardMediaImageError };
